import { Construtor } from './construtor';
import { ResultadoCriterioColeta } from './resultado-criterio-coleta';

export class ResultadoColeta implements Construtor<ResultadoColeta> {

  public idCliente: number;
  public filtroIdUsuario: number[];
  public idPontoFisico: number;
  public nomePontoFisico: string;
  public idSetor: number;
  public nomeSetor: string;
  public idProcesso: number;
  public nomeProcesso: string;
  public idRotinaCliente: number;
  public descricaoRotina: string;
  public dataInicioReferencia: Date;
  public dataFimReferencia: Date;
  public resultadosCriterioColeta: ResultadoCriterioColeta[];
  public pesquisaComFoto: boolean;
  public chartData: any[];

  constructor(object?: any) {
    this.resultadosCriterioColeta = new Array<ResultadoCriterioColeta>();
    this.chartData = new Array<any>();
    this.filtroIdUsuario = new Array<number>();
    if (object !== undefined) {
      if (object instanceof (ResultadoColeta)) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }
    }
  }

  parseFromJson(resultadoColeta: any): void {
    this.idCliente = resultadoColeta.idCliente;
    this.filtroIdUsuario = resultadoColeta.filtroIdUsuario;
    this.idPontoFisico = resultadoColeta.idPontoFisico;
    this.nomePontoFisico = resultadoColeta.nomePontoFisico;
    this.idSetor = resultadoColeta.idSetor;
    this.nomeSetor = resultadoColeta.nomeSetor;
    this.idProcesso = resultadoColeta.idProcesso;
    this.nomeProcesso = resultadoColeta.nomeProcesso;
    this.idRotinaCliente = resultadoColeta.idRotinaCliente;
    this.descricaoRotina = resultadoColeta.descricaoRotina;
    this.resultadosCriterioColeta = resultadoColeta.resultadosCriterioColeta;
    this.dataFimReferencia = resultadoColeta.dataFimReferencia;
    this.dataInicioReferencia = resultadoColeta.dataInicioReferencia;
    this.pesquisaComFoto = resultadoColeta.pesquisaComFoto;
  }

  copyObject(resultadoColeta: ResultadoColeta): void {
    this.idCliente = resultadoColeta.idCliente;
    this.filtroIdUsuario = resultadoColeta.filtroIdUsuario;
    this.idPontoFisico = resultadoColeta.idPontoFisico;
    this.nomePontoFisico = resultadoColeta.nomePontoFisico;
    this.idSetor = resultadoColeta.idSetor;
    this.nomeSetor = resultadoColeta.nomeSetor;
    this.idProcesso = resultadoColeta.idProcesso;
    this.nomeProcesso = resultadoColeta.nomeProcesso;
    this.idRotinaCliente = resultadoColeta.idRotinaCliente;
    this.descricaoRotina = resultadoColeta.descricaoRotina;
    this.resultadosCriterioColeta = resultadoColeta.resultadosCriterioColeta;
    this.dataFimReferencia = resultadoColeta.dataFimReferencia;
    this.dataInicioReferencia = resultadoColeta.dataInicioReferencia;
    this.pesquisaComFoto = resultadoColeta.pesquisaComFoto;
  }

  modeloCompleto(): boolean {
    return this.nomePontoFisico !== undefined && this.nomeSetor !== undefined && this.nomeProcesso !== undefined
      && this.descricaoRotina !== undefined;
  }

  getNewInstance(object?: any): ResultadoColeta {
    return new ResultadoColeta(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/resultado-coleta.ts